
  import createMeisterIcons from '../src/createMeisterIcons';

  const DivideBlock = createMeisterIcons("divide-block", [["path",{"fill":"currentColor","d":"M16.62 4.98a.52.52 0 0 0-.74 0l-10.9 10.9a.52.52 0 0 0 0 .74l2.4 2.4a.517.517 0 0 0 .74 0l10.9-10.9a.52.52 0 0 0 0-.74zm-1.8-1.06a2.017 2.017 0 0 1 2.86 0l2.4 2.4a2.017 2.017 0 0 1 0 2.86l-10.9 10.9a2.017 2.017 0 0 1-2.86 0l-2.4-2.4a2.02 2.02 0 0 1 0-2.86z","key":"dd46bee4144d50c7e2275591f947136298adf7b2","fillRule":"evenodd","clipRule":"evenodd"}]])

  export default DivideBlock
  